const prependZero = (number: any, type = 10) => {
  let str = number;
  if (number < type) {
    str = '0' + number;
  }
  return str;
}

export default prependZero;